<template>
  <v-list-item ripple class="pl-6 pr-0 py-1" >
    <v-list-item-avatar class="my-0 ml-0 mr-1">
      <v-img
          eager
          :style="{backgroundColor: getBackgroundColor}"
          :src="getImage"
      />
    </v-list-item-avatar>
    <v-list-item-content class="py-0">
      <v-list-item-title>
        {{ orderItem.product.name.charAt(0).toUpperCase() + orderItem.product.name.toLowerCase().substring(1) }}
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action class="ma-0">
      <v-chip class="grey--text text--darken-2 grey lighten-3">{{ orderItem.quantity }}</v-chip>
    </v-list-item-action>

  </v-list-item>
</template>

<script>
import ProductMixin from "@/modules/delivery/mixins/ProductMixin";

export default {
  name: "CustomerCartDetailPromoProduct",
  props: {
    orderItem: {
      type: Object,
      required: true
    },
  },
  mixins: [ProductMixin],
  computed: {
    getImage() {
        let imageCategory
        if (this.orderItem.product.imageCategory) {
          imageCategory = this.orderItem.product.imageCategory.find(i => i.category === this.category.id)
        }
        return (imageCategory && imageCategory.image) ? imageCategory.image : this.orderItem.product.image
    },
    getBackgroundColor() {
        return this.orderItem.category.backgroundColor ? this.orderItem.category.backgroundColor : null
    },
  },
}
</script>

<style scoped>

</style>
